export default __webpack_public_path__ + "images/AMX.b4c16c5.png";